module.exports = __webpack_public_path__ + "img/empty-datatable.da168f10.png";